import { Component, Inject } from '@angular/core';
import { TopnavComponent } from './components/topnav/topnav.component';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SliderModule } from 'primeng/slider';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { LoginLoadComponent } from "../../core/pages/login-load/login-load.component";
import { AuthService } from '@core/services/auth/auth.service';
import { FilterService } from '@modules/search/services/filter.service';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    RouterOutlet,
    TopnavComponent,
    FormsModule,
    SliderModule,
    LoaderComponent,
    CommonModule,
    LoginLoadComponent
],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  animations: [
    // top to bottom animation from opacity 0 to 1 translate y -50% to 0
    trigger('slideInTop', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-50%)' }),
        animate(
          '0.5s 1s ease-in-out',
          style({ opacity: 1, transform: 'translateY(0%)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '0.5s 1s ease-in-out',
          style({ opacity: 0, transform: 'translateY(-50%)' })
        ),
      ]),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  value = 16;
  isLoading : boolean = true;
  constructor(
    @Inject(DOCUMENT) private doc: Document,
    protected _auth : AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private filter: FilterService
  ) {}

  ngOnInit() {
    // Check for messageId query param and open the corresponding mail
    this.route.queryParams.subscribe(params => {
      const messageId = params['messageId'];
      if (messageId) {
        // Clear the query parameters from URL to avoid repeated processing
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true
        });

        let messageIdFilter = {
          "name": "message id",
          "esName": "metaData.message-id",
          "value": messageId,
          "logicalOperator": "must",
          "matchType": "exact",
          "type": "filter"
        };
        this.filter.applyFilterAndSelectFirst([messageIdFilter]);
      }
    });
  }

  onModelChange = () => {
    document.documentElement.style.setProperty(
      `--dd-fontsize`,
      `${this.value}px`
    );
  };

  onLoading = (event: any) => {
    this.isLoading = event;
  };
}
